module.exports = __webpack_public_path__ + "fa5f1a4c0856c157d948ac2e4ee30e51.png";